<template>
  <div class="my-pooq-content-body">
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
      <my-pooq-empty-list v-if="!isLoading && alarmList.length === 0" info-text="시청예약알림 내역이 없어요."></my-pooq-empty-list>
      <ul class="seen-list" v-else-if="alarmList.length > 0">
        <li v-for="(alarm, index) in alarmList" :key="alarm.contentid + index">
          <a href="#" @click.prevent="()=>{}">
            <div class="picture-area landscape">
              <WebpImage :image-info="{imageUrl: alarm.image, width: 312, height:176, alt: alarm.contenttitle}" />
            </div>
            <span class="thum-info">
                <strong class="thum-title" v-html="alarm.contenttitle"></strong>
                  <span class="thum-date">
                    <span>방송일시</span>
                    <i class="icon-dotted"></i>
                    <span>{{alarm.releasedatetime}}</span>
                  </span>
                  <span class="thum-date">{{alarm.channeltitle}}</span>
              </span>
            <button class="icon-alarm" @click.prevent="() => clickAlarm(alarm)">
              <AlarmOn v-if="alarm.on"/>
              <AlarmOff v-else/>
            </button>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { infiniteScroll } from '@/common/directives'
import { MyPooqService, commonErrorProcess } from '@/common/api/api.service'
import { get } from 'lodash'
import { resizeThumbnail } from '@/common/image.filter'
import AlarmOn from '@/assets/svg/common/ic-detail-alart-on.svg'
import AlarmOff from '@/assets/svg/common/ic-detail-alart-off.svg'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import WebpImage from '@/components/image/WebpImage'
export default {
  name: 'MyPooqArarm',
  directives: {
    infiniteScroll
  },
  components: {
    WebpImage,
    MyPooqEmptyList,
    AlarmOn,
    AlarmOff
  },
  data () {
    return {
      offset: 0,
      limit: 20,
      isDeleteMode: false,
      showEmptyList: false,
      endOfList: false,
      alarmList: [],
      isLoading: false
    }
  },
  methods: {
    clickAlarm (alarm) {
      let registAlarmApi, deleteAlarmApi
      if (!alarm.on) {
        if (alarm.contenttype === 'baseball_live') {
          registAlarmApi = MyPooqService.postZzimBaseball({ alarmtype: alarm.contenttype, gameid: alarm.gameid, contentid: alarm.contentid, image: '', contenttitle: alarm.contenttitle, channeltitle: '', releasedatetime: alarm.releasedatetime })
        } else {
          registAlarmApi = MyPooqService.registAlarm({ alarmtype: alarm.contenttype, contentid: alarm.contentid, releasedatetime: alarm.releasedatetime, programid: '' })
        }
        registAlarmApi.then(({ data }) => {
          if (get(data, 'resultcode', '') === '200' && get(data, 'resultmessage', '') === 'success') {
            this.$toast({ message: '시청예약 되었습니다.' })
            this.$nextTick(() => {
              alarm.on = true
            })
          }
        }).catch(commonErrorProcess)
      } else {
        if (alarm.contenttype === 'baseball_live') {
          deleteAlarmApi = MyPooqService.deleteZzimBaseball({ alarmtype: alarm.contenttype, contentid: alarm.contentid, releasedatetime: alarm.releasedatetime })
        } else {
          deleteAlarmApi = MyPooqService.deleteAlarm({ alarmtype: alarm.contenttype, contentid: alarm.contentid, releasedatetime: alarm.releasedatetime })
        }
        deleteAlarmApi.then(({ data }) => {
          if (get(data, 'resultcode', '') === '200' && get(data, 'resultmessage', '') === 'success') {
            this.$toast({ message: '시청예약 알림이 취소 되었습니다.' })
            this.$nextTick(() => {
              alarm.on = false
            })
          }
        }).catch(commonErrorProcess)
      }
    },
    getLazyLoadObj (alarm) {
      return {
        src: resizeThumbnail(alarm.image, { width: 312, height: 176 }),
        error: '/img/common/img_default_thum_2.png',
        loading: '/img/common/img_default_thum_2.png'
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      MyPooqService.alarmList({
        limit: this.limit,
        offset: this.offset,
        contenttype: 'live'
      }).then(({ data }) => {
        let resList = get(data, 'list', [])
        resList = resList.map((alarm) => {
          alarm.on = true
          return alarm
        })
        this.endOfList = resList.length === 0
        this.showEmptyList = this.alarmList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.alarmList = this.alarmList.concat(resList)
        this.isLoading = false
      })
    }
  }
}
</script>
